import { DISTANT_HERO } from "../../ProductHeroes";
import bassSuiteImage from "../../../static/images/distant_amplifier_bundle/bass-suite.webp";

export const INCLUDED_PRODUCTS = [
  {
    id: "distant-amplifier-suite",
    name: "ToneSuite - Distant",
    instrument: "Guitar",
    image: DISTANT_HERO.src,
    width: DISTANT_HERO.width,
    height: DISTANT_HERO.height,
    description: "Raw, powerful guitar tones with the aggression and weight of Distant. Shape tight rhythms and crushing distortion without polishing away their character.",
    features: [
      "Fleshweaver, Servant and Nailwound amplifiers",
      "Cabinet, pedal, EQ and effects sections",
      "Plugin and standalone operation",
    ],
  },
  {
    id: "distant-bass-suite",
    name: "BassSuite - Distant",
    instrument: "Bass",
    image: bassSuiteImage,
    width: 1600,
    height: 1079,
    description: "The low-end counterpart to ToneSuite. Build a tight, punchy foundation or push into filthy distortion, with bass tones that hold their own in a dense guitar mix.",
    features: [
      "Skinscraper and Fleshweaver bass amplifiers",
      "Cabinets, compression, EQ and bass-shaping tools",
      "Plugin and standalone operation",
    ],
  },
];

export interface StoreProduct {
  id: string;
  name: string;
  metadata?: Record<string, string>;
  owned?: boolean;
  default_price?: {
    id: string;
    currency: string;
    unit_amount: number;
  } | null;
}

export function getProductPrice(product?: StoreProduct) {
  const price = product?.default_price;
  if (!price?.id || !/^[a-z]{3}$/i.test(price.currency) ||
    !Number.isSafeInteger(price.unit_amount) || price.unit_amount < 0) {
    return undefined;
  }
  return price;
}

export function formatPrice(amount: number, currency: string) {
  const formatter = new Intl.NumberFormat("en-IE", { style: "currency", currency });
  const decimals = formatter.resolvedOptions().maximumFractionDigits;
  return formatter.format(amount / Math.pow(10, decimals));
}
